import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationInfo } from 'src/app/interfaces/notification.interface';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    public err = new BehaviorSubject<any>(null);
    constructor(private http: HttpClient) {}

    exportAllNotification() {
        return new Promise<NotificationInfo[]>((resolve, reject) => {
            this.http
                .get(environment.backEndUrl + '/httpNotificationGetAll')
                .toPromise()
                .then((data: any) => {
                  try{
                    data = data.sort(
                        (obj1: any, obj2: any) =>{
                          let obj1date=obj1.date.replace(/(\d+[/])(\d+[/])/, '$2$1');
                          let obj2date=obj2.date.replace(/(\d+[/])(\d+[/])/, '$2$1');                          
                          return new Date(obj2date).getTime() -
                            new Date(obj1date).getTime()
                        }
                            
                    );                    
                  }catch{
                  }
                  localStorage.setItem('notification-count', data.length.toString());

                    this.err.next(null);
                    resolve(data);
                })
                .catch((err) => reject(err));
        });
    }

    getNotificationCount() {
      return new Promise<any>((resolve, reject) => {
          this.http
              .get(environment.backEndUrl + '/httpNotificationGetCount')
              .toPromise()
              .then((data) => {
                  resolve(data)
              }).catch((err=>resolve(err)));
      });
  }
}
